module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "id": "login-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register()
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Регистрация")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errors.username[0]
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Имя пользователя")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.username),
      expression: "data.username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Введите желаемое имя пользователя"
    },
    domProps: {
      "value": (_vm.data.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.username[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errors.password[0]
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password),
      expression: "data.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Введите пароль"
    },
    domProps: {
      "value": (_vm.data.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.password[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errors.password2[0]
    }
  }, [_c('label', {
    attrs: {
      "for": "password2"
    }
  }, [_vm._v("Пароль еще раз")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password2),
      expression: "data.password2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password2",
      "type": "password",
      "placeholder": "Введите пароль повторно"
    },
    domProps: {
      "value": (_vm.data.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "password2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.password2[0]))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Уже зарегистрированы? Войдите здесь")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit",
      "value": "Зарегистрироваться"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6287e675","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Register.vue
// module id = 658
// module chunks = 0